module.exports = __webpack_public_path__ + "img/亮点2_03.dd5a7c2d.jpg";